var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm._loading)?_c('AppStateQuotation',{ref:"AppStateQuotation",attrs:{"quotation":_vm.modelData},on:{"save":function($event){return _vm.$_onSave($event)}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }